import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = { style: {"width":"70px"} }
const _hoisted_4 = { style: {"width":"70px","margin-left":"auto"} }
const _hoisted_5 = { class: "chat-date-nav" }
const _hoisted_6 = { class: "chat-date-nav-year pa-1" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "chat-date-nav-side chat-date-nav-side-left" }
const _hoisted_9 = {
  class: "pink--text text-subtitle-1 mr-1",
  style: {"color":"#E91E63 !important"}
}
const _hoisted_10 = { class: "chat-date-nav-center" }
const _hoisted_11 = { class: "chat-date-nav-date d-flex align-end" }
const _hoisted_12 = { style: {"margin-left":"2px !important","margin-right":"2px !important"} }
const _hoisted_13 = { class: "chat-date-nav-side chat-date-nav-side-right" }
const _hoisted_14 = {
  class: "pink--text text-subtitle-1 ml-1",
  style: {"color":"#E91E63 !important"}
}
const _hoisted_15 = {
  class: "d-flex w-100 pa-0",
  style: {"height":"47px"}
}
const _hoisted_16 = {
  class: "pink--text text-subtitle-1 ml-1",
  style: {"color":"#E91E63 !important"}
}
const _hoisted_17 = {
  class: "pink--text text-subtitle-1 ml-1",
  style: {"color":"#E91E63 !important"}
}
const _hoisted_18 = {
  class: "pink--text text-subtitle-1 ml-1",
  style: {"color":"#E91E63 !important"}
}
const _hoisted_19 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass(`
        chats-wrapper
        d-flex
        flex-column
        no-scroll-bar
      `)
}
const _hoisted_20 = {
  class: "text-center",
  style: {"user-select":"none"}
}
const _hoisted_21 = { style: {"user-select":"none","width":"100%"} }
const _hoisted_22 = {
  key: 0,
  class: "d-flex align-end blue-grey--text caption flex-shrink-0"
}
const _hoisted_23 = { class: "meta" }
const _hoisted_24 = {
  key: 0,
  class: "ma-0"
}
const _hoisted_25 = { class: "ma-0 text-right-wrap" }
const _hoisted_26 = ["innerHTML", "onClick"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 1,
  class: "d-flex align-end blue-grey--text caption flex-shrink-0"
}
const _hoisted_30 = { class: "meta" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "ma-0" }
const _hoisted_34 = {
  key: 1,
  class: "input-wrapper d-flex"
}
const _hoisted_35 = { class: "btn-wrapper" }
const _hoisted_36 = {
  class: "text-center",
  style: {"user-select":"none"}
}
const _hoisted_37 = { class: "info-wrapper pa-2 mx-1 my-2" }
const _hoisted_38 = { class: "body-2 font-weight-bold" }
const _hoisted_39 = { style: {"white-space":"pre-wrap"} }
const _hoisted_40 = {
  key: 0,
  style: {"white-space":"pre-wrap"}
}
const _hoisted_41 = { class: "mt-2 d-flex justify-center" }
const _hoisted_42 = { class: "pa-1" }
const _hoisted_43 = { class: "d-flex flex-column" }
const _hoisted_44 = {
  class: "text-center",
  style: {"user-select":"none"}
}
const _hoisted_45 = { class: "info-wrapper pa-2 mx-1 my-2" }
const _hoisted_46 = { class: "body-2 font-weight-bold" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { style: {"white-space":"pre-wrap"} }
const _hoisted_50 = { class: "mt-2 d-flex justify-center" }
const _hoisted_51 = { class: "pa-1" }
const _hoisted_52 = { class: "pdf_header_wrapper" }
const _hoisted_53 = { class: "pdf" }
const _hoisted_54 = ["data"]
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "fallback-link" }
const _hoisted_57 = ["href"]
const _hoisted_58 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_59 = {
  key: 0,
  class: "d-flex px-3"
}
const _hoisted_60 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_61 = { class: "d-flex flex-column" }
const _hoisted_62 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_absence_modal = _resolveComponent("absence-modal")!
  const _component_calendar_modal = _resolveComponent("calendar-modal")!
  const _component_pickup_modal = _resolveComponent("pickup-modal")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_translation_modal = _resolveComponent("translation-modal")!
  const _component_email_send_modal = _resolveComponent("email-send-modal")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, { onClick: _ctx.routerBack }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_v_toolbar_title, {
            style: {"position":"absolute","left":"50%","margin":"0","padding":"0","max-width":"70%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
            class: "text-center chat-toolbar-child-name chat-title-custom"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.childName), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_btn, { onClick: _ctx.toRecordByDay }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('chat.header.record')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        tile: "",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.t('chat.header.year', '', { year: _ctx.year })), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.unReadCount.beforeTheDate > 0)
                ? (_openBlock(), _createBlock(_component_v_badge, {
                    key: 0,
                    content: _ctx.unReadCount.beforeTheDate,
                    value: _ctx.unReadCount.beforeTheDate,
                    color: "red",
                    class: _normalizeClass({ 'badge-prev-day-en-custom': _ctx.isEnglishLocale }),
                    "offset-x": _ctx.prevDayUnreadBadgeOffsetX,
                    "offset-y": _ctx.dateNavUnreadBadgeOffsetY
                  }, null, 8, ["content", "value", "class", "offset-x", "offset-y"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                onClick: _ctx.toPrevDate,
                class: "no-background-hover px-0",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { color: "primary" }, {
                    default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('chat.header.prevDay')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.today), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(`(${_ctx.dayOfTheWeek})`), 1)
              ]),
              _createVNode(_component_v_icon, {
                class: "chat-date-nav-calendar",
                medium: "",
                disabled: _ctx.fetchLoading,
                onClick: _ctx.openCalendarModal
              }, {
                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                  _createTextVNode(" mdi-calendar-filter", -1)
                ]))]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.unReadCount.afterTheDate > 0)
                ? (_openBlock(), _createBlock(_component_v_badge, {
                    key: 0,
                    content: _ctx.unReadCount.afterTheDate,
                    value: !_ctx.unReadCount.afterTheDate,
                    color: "red",
                    "offset-x": "0",
                    "offset-y": _ctx.dateNavUnreadBadgeOffsetY
                  }, null, 8, ["content", "value", "offset-y"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                onClick: _ctx.toNextDate,
                class: "no-background-hover px-0",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t('chat.header.nextDay')), 1),
                  _createVNode(_component_v_icon, { color: "primary" }, {
                    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.tabs,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabs) = $event)),
              "fixed-tabs": "",
              style: {"margin-left":"calc(-50vw + 50%)"},
              "slider-color": "pink",
              grow: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { href: "#chat" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.t('chat.tabs.chat')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { href: "#absence" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.t('chat.tabs.absence')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { href: "#pickup" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.t('chat.tabs.pickup')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "grey-border" }, null, -1))
    ]),
    (_ctx.tabs === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_ctx.isChatMenu)
            ? (_openBlock(), _createBlock(_component_v_overlay, {
                key: 0,
                color: "rgba(1, 1, 1, 0)"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "chat_menu-wrapper d-flex justify-center align-center",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.isChatMenu = false), ["self"]))
                  }, [
                    _withDirectives((_openBlock(), _createElementBlock("div", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteChat && _ctx.deleteChat(...args))),
                      class: "chat_menu pa-1 d-flex justify-center align-center",
                      style: _normalizeStyle(`position: absolute; left: ${_ctx.chatMenuX}px; top: ${_ctx.chatMenuY}px`)
                    }, [
                      _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.t('chat.menu.delete')), 1)
                    ], 4)), [
                      [_directive_ripple]
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_vue_loading, {
            loader: "bars",
            active: _ctx.fetchLoading,
            color: "#EE6090",
            size: { width: '50px', height: '50px' }
          }, null, 8, ["active"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chats, (c) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: c.chatId + c.createdAt,
              class: _normalizeClass(`chat-wrapper d-flex ${
          c.from === null ? 'justify-end align-self-end' : ''
        }`)
            }, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: _normalizeClass(`
              message-wrapper
              d-flex align-end
              ${c.from === null ? 'justify-end align-self-end' : ''}
            `)
                }, [
                  (c.from === null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          (c.readAt)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.t('chat.message.read')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.formatMinutes(c.deliveredAt)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(`
                ${c.from === null ? 'parents-chat' : 'staff-chat'}
                chat-body pa-2 mx-1 mt-1 no-scroll-bar
                ${c.bodyType === 'groupChat' ? 'group-chat' : ''}
              `)
                  }, [
                    _withDirectives(_createElementVNode("span", { class: "font-weight-bold" }, _toDisplayString(_ctx.t('chat.message.groupChatLabel')), 513), [
                      [_vShow, c.bodyType === 'groupChat']
                    ]),
                    _createElementVNode("p", {
                      innerHTML: _ctx.escapeAndLinkify(_ctx.displayChatBody(c)),
                      class: "autolinked",
                      style: {"white-space":"pre-wrap","overflow-wrap":"break-word"},
                      onClick: ($event: any) => (_ctx.handleContentClick(c, $event))
                    }, null, 8, _hoisted_26),
                    (c.attachmentUrls?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.attachmentUrls, (au, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: au.objectKey
                            }, [
                              (!_ctx.isPdf(au.objectKey))
                                ? (_openBlock(), _createBlock(_component_v_card, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.openChatImg(c, index)),
                                    class: "pointer mt-1",
                                    elevation: "0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_img, {
                                        src: au.url ?? undefined,
                                        contain: ""
                                      }, null, 8, ["src"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createVNode(_component_v_btn, {
                                      class: "mt-3 justify-start",
                                      color: "primary",
                                      variant: "outlined",
                                      block: "",
                                      onClick: ($event: any) => (_ctx.openChatImg(c, index)),
                                      loading: _ctx.imgLoading
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t('chat.message.showAttachment')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick", "loading"])
                                  ]))
                            ]))
                          }), 128)),
                          _createVNode(_component_v_btn, {
                            class: "mt-1 justify-start",
                            color: "primary",
                            variant: "outlined",
                            onClick: ($event: any) => (_ctx.handleSendPdf(c)),
                            loading: _ctx.imgLoading
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('chat.message.sendAttachmentByEmail')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick", "loading"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  (c.from !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          (!_ctx.translatedChats[c.chatId])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createVNode(_component_v_btn, {
                                  style: {"height":"18px","color":"#000000","border-color":"#000000","border-width":"1px"},
                                  onClick: ($event: any) => (_ctx.openTranslateDialog(c))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "small" }, {
                                      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                        _createTextVNode("mdi-google-translate", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createVNode(_component_v_btn, {
                                  style: {"height":"16px","color":"#000000","border-color":"#000000","border-width":"1px"},
                                  onClick: ($event: any) => (_ctx.returnTranslate(c.chatId))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { small: "" }, {
                                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                        _createTextVNode("mdi-arrow-u-left-top", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])),
                          _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.formatMinutes(c.deliveredAt)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (c.from === null && c.bodyType === 'message')
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 2,
                        icon: "",
                        onClick: ($event: any) => (_ctx.handleContentClick(c, $event)),
                        small: "",
                        flat: "",
                        class: "align-self-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                              _createTextVNode("mdi-dots-vertical-circle-outline", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 2)
              ])), [
                [_vShow, c.bodyType === 'message' || c.bodyType === 'groupChat' || c.bodyType === 'absence' || c.bodyType === 'pickup'],
                [_directive_touch, _ctx.showChatMenu(c), "touchhold"]
              ])
            ], 2)), [
              [_vShow, !_ctx.fetchLoading]
            ])
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.tabs === 0 && _ctx.isChatEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createVNode(_component_v_textarea, {
            class: "chat_textarea",
            modelValue: _ctx.chatInput,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.chatInput) = $event)),
            "auto-grow": "",
            rules: [_ctx.rules.counter1000],
            onFocus: _ctx.chatsScrollToBottom,
            color: "primary",
            variant: "outlined",
            rows: "1",
            "row-height": "15",
            "hide-details": "",
            dense: ""
          }, null, 8, ["modelValue", "rules", "onFocus"]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_v_btn, {
              onClick: _ctx.postChats,
              loading: _ctx.postLoading,
              class: "send-button ml-1",
              color: "primary",
              depressed: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('chat.input.send')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.tabs === 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(`
        chats-wrapper
        d-flex
        flex-column
        no-scroll-bar
        ${_ctx.isSafeArea ? '' : 'pb-12'}
      `)
        }, [
          (_ctx.isChatMenu)
            ? (_openBlock(), _createBlock(_component_v_overlay, {
                key: 0,
                color: "rgba(1, 1, 1, 0)"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "chat_menu-wrapper d-flex justify-center align-center",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.isChatMenu = false), ["self"]))
                  }, [
                    _withDirectives((_openBlock(), _createElementBlock("div", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteChat && _ctx.deleteChat(...args))),
                      class: "chat_menu pa-1 d-flex justify-center align-center",
                      style: _normalizeStyle(`position: absolute; left: ${_ctx.chatMenuX}px; top: ${_ctx.chatMenuY}px`)
                    }, [
                      _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.t('chat.menu.delete')), 1)
                    ], 4)), [
                      [_directive_ripple]
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_vue_loading, {
            loader: "bars",
            color: "#EE6090",
            size: { width: '50px', height: '50px' }
          }, null, 512), [
            [_vShow, _ctx.fetchLoading]
          ]),
          (!_ctx.fetchLoading && _ctx.absence !== null && !!_ctx.absence?.reason)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 1,
                class: "ma-2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_v_card_title, { class: "mb-3" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.t('chat.absence.title')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.formatReason(_ctx.absence?.reason)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      (_ctx.absence.comment)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.absence.comment), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_v_btn, {
                        onClick: _ctx.deleteAbsence,
                        loading: _ctx.deleteAbsenceLoading,
                        color: "primary",
                        depressed: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('chat.action.cancel')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "loading"])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_42, [
            (!_ctx.isQuit && !_ctx.absence?.reason)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isAbsenceDialog = true)),
                  class: "outline",
                  color: "primary",
                  block: "",
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('chat.tabs.absence')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.actionDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.actionDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_43, [
              (_ctx.chatType != 'groupChat')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clickDeleteDialog(_ctx.tempChat)))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t('chat.menu.delete')), 1),
                      _createVNode(_component_v_icon, { end: "" }, {
                        default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                          _createTextVNode("mdi-trash-can-outline", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isAbsenceDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isAbsenceDialog) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_absence_modal, {
          isOpen: _ctx.isAbsenceDialog,
          childId: _ctx.childId,
          onPosted: _ctx.fetchChats,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isAbsenceDialog = false))
        }, null, 8, ["isOpen", "childId", "onPosted"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isCalendarDialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isCalendarDialog) = $event)),
      width: "350px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        (_ctx.isCalendarDialog)
          ? (_openBlock(), _createBlock(_component_calendar_modal, {
              key: 0,
              isOpen: _ctx.isCalendarDialog,
              childId: _ctx.childId,
              calendar: _ctx.calendar || [],
              calendarDate: _ctx.calendarDate || [],
              onPosted: _ctx.fetchChats,
              onSelectDate: _ctx.dateSelected,
              onClose: _ctx.closeCalendarModal,
              "onClick:outside": _ctx.closeCalendarModal
            }, null, 8, ["isOpen", "childId", "calendar", "calendarDate", "onPosted", "onSelectDate", "onClose", "onClick:outside"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.tabs === 2)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(`
        chats-wrapper
        d-flex
        flex-column
        no-scroll-bar
        ${_ctx.isSafeArea ? '' : 'pb-12'}
      `)
        }, [
          (_ctx.isChatMenu)
            ? (_openBlock(), _createBlock(_component_v_overlay, {
                key: 0,
                color: "rgba(1, 1, 1, 0)"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "chat_menu-wrapper d-flex justify-center align-center",
                    onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.isChatMenu = false), ["self"]))
                  }, [
                    _withDirectives((_openBlock(), _createElementBlock("div", {
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.deleteChat && _ctx.deleteChat(...args))),
                      class: "chat_menu pa-1 d-flex justify-center align-center",
                      style: _normalizeStyle(`position: absolute; left: ${_ctx.chatMenuX}px; top: ${_ctx.chatMenuY}px`)
                    }, [
                      _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.t('chat.menu.delete')), 1)
                    ], 4)), [
                      [_directive_ripple]
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_vue_loading, {
            loader: "bars",
            color: "#EE6090",
            size: { width: '50px', height: '50px' }
          }, null, 512), [
            [_vShow, _ctx.fetchLoading]
          ]),
          (!_ctx.fetchLoading && _ctx.pickup !== null && _ctx.pickup?.reason)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 1,
                class: "ma-2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_v_card_title, { class: "mb-3" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.t('chat.pickup.title')), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.pickup.dropOff.time)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.t('chat.pickup.dropOffBy')) + _toDisplayString(_ctx.pickup.dropOff.by ? _ctx.translateParentRelationLabel(_ctx.pickup.dropOff.by.value) : ''), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.t('chat.pickup.dropOffTime')) + _toDisplayString(_ctx.formatPickupTime(_ctx.pickup.dropOff.time)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.pickup.pickup.time)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.t('chat.pickup.pickupBy')) + _toDisplayString(_ctx.pickup.pickup.by ? _ctx.translateParentRelationLabel(_ctx.pickup.pickup.by.value) : ''), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.t('chat.pickup.pickupTime')) + _toDisplayString(_ctx.formatPickupTime(_ctx.pickup.pickup.time)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.pickup?.reason), 1)
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_v_btn, {
                        onClick: _ctx.deletePickup,
                        loading: _ctx.deletePickupLoading,
                        color: "primary",
                        depressed: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('chat.action.cancel')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "loading"])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_51, [
            (!_ctx.isQuit)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isPickupDialog = true)),
                  class: "outline",
                  color: "primary",
                  block: "",
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('chat.tabs.pickup')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isPickupDialog,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isPickupDialog) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_pickup_modal, {
          isOpen: _ctx.isPickupDialog,
          childId: _ctx.childId,
          onPosted: _ctx.fetchChats,
          onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isPickupDialog = false))
        }, null, 8, ["isOpen", "childId", "onPosted"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      class: "pt-5",
      modelValue: _ctx.isAttachmentUrls,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isAttachmentUrls) = $event)),
      fullscreen: "",
      "hide-overlay": "",
      transition: "dialog-bottom-transition"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pdf_wrapper pt-5" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_v_toolbar, {
                class: "pdf_header",
                dark: "",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    dark: "",
                    onClick: _ctx.closeChatImg,
                    absolute: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.childName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_53, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showingUrls, (u) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: u.objectKey
                }, [
                  _createElementVNode("object", {
                    data: u.url,
                    type: "application/pdf",
                    width: "100%",
                    height: "100%"
                  }, [
                    _createElementVNode("iframe", {
                      src: u.url,
                      width: "100%",
                      height: "100%",
                      frameborder: "0",
                      allowfullscreen: ""
                    }, " お使いのブラウザは iframe に対応していません。 ", 8, _hoisted_55),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("a", {
                        href: u.url,
                        target: "_blank",
                        rel: "noopener"
                      }, " PDF をダウンロード ", 8, _hoisted_57)
                    ])
                  ], 8, _hoisted_54)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isImgDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.isImgDialog) = $event)),
      fullscreen: "",
      transition: "dialog-bottom-transition"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          width: "100%",
          rounded: "b-0",
          class: "img_dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              height: "40px",
              class: "d-flex justify-end align-center px-2 img_dialog-header",
              rounded: "b-0",
              dark: "",
              elevation: "0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  class: "blue--text",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isImgDialog = false))
                }, _toDisplayString(_ctx.t('chat.action.close')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              height: "calc(100vh - 40px)",
              width: "100%",
              rounded: "0",
              dark: "",
              class: "d-flex flex-grow-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  class: "img_dialog-img",
                  width: "100%",
                  contain: "",
                  src: _ctx.notPdfImgSrc ?? undefined,
                  alt: "img"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.deleteDialog,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.deleteDialog) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_58, [
              _createVNode(_component_v_card_title, { class: "headline lighten-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('chat.confirm.deleteTitle')), 1)
                ]),
                _: 1
              })
            ]),
            (_ctx.tempChat.body)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createVNode(_component_v_card_subtitle, {
                    style: {"white-space":"pre-line","user-select":"none"},
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.showLongText(_ctx.tempChat.body)), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_60, [
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "error",
                    onClick: _cache[20] || (_cache[20] = () => (_ctx.deleteDialog = false)),
                    depressed: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('chat.action.cancelBtn')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "error",
                    class: "ml-5",
                    depressed: "",
                    variant: "flat",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.deleteChatById())),
                    loading: _ctx.deleteLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('chat.menu.delete')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.actionDialog,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.actionDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_61, [
              (_ctx.chatType != 'groupChat')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.clickDeleteDialog(_ctx.tempChat)))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t('chat.menu.delete')), 1),
                      _createVNode(_component_v_icon, { end: "" }, {
                        default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                          _createTextVNode("mdi-trash-can-outline", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_62, [
              (_ctx.chatType != 'groupChat')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onCopyTextCopy()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t('chat.menu.copy')), 1),
                      _createVNode(_component_v_icon, { end: "" }, {
                        default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                          _createTextVNode("mdi-content-copy", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isTranslationDialog,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.isTranslationDialog) = $event)),
      persistent: "",
      "max-width": "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_translation_modal, {
          isOpen: _ctx.isTranslationDialog,
          childId: _ctx.childId,
          selectedChat: _ctx.translationChat,
          onTranslate: _ctx.onTranslated,
          onClose: _cache[26] || (_cache[26] = ($event: any) => (_ctx.isTranslationDialog = false))
        }, null, 8, ["isOpen", "childId", "selectedChat", "onTranslate"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_email_send_modal, {
      modelValue: _ctx.isEmailSendDialog,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.isEmailSendDialog) = $event)),
      email: this.me?.email,
      "chat-id": this.selectedChat?.chatId,
      onError: _ctx.sendEmailError,
      onSuccess: _ctx.sendEmailSuccess,
      onClose: _cache[29] || (_cache[29] = ($event: any) => (_ctx.isEmailSendDialog = false)),
      "content-class": "email-dialog",
      persistent: ""
    }, null, 8, ["modelValue", "email", "chat-id", "onError", "onSuccess"])
  ]))
}